export default __webpack_public_path__ + "static/media/Topografía.37baa6a6.png";